"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AboutPage = _interopRequireDefault(require("Pages/AboutPage"));
var _BecomeVolonteer = _interopRequireDefault(require("Pages/BecomeVolonteer"));
var _CandidateAccountPage = _interopRequireDefault(require("Pages/CandidateAccountPage"));
var _CandidateCvPage = _interopRequireDefault(require("Pages/CandidateCvPage"));
var _CompanyAccountPage = _interopRequireDefault(require("Pages/CompanyAccountPage"));
var _DonatePage = _interopRequireDefault(require("Pages/DonatePage"));
var _ForgottenPasswordPage = _interopRequireDefault(require("Pages/ForgottenPasswordPage"));
var _FormationSensibilisationPage = _interopRequireDefault(require("Pages/FormationSensibilisationPage"));
var _HomePage = _interopRequireDefault(require("Pages/HomePage"));
var _InfoCandidatePage = _interopRequireDefault(require("Pages/InfoCandidatePage"));
var _InfoCompanyPage = _interopRequireDefault(require("Pages/InfoCompanyPage"));
var _JobAdCompanyPage = _interopRequireDefault(require("Pages/JobAdCompanyPage"));
var _MaintienEmploiPage = _interopRequireDefault(require("Pages/MaintienEmploiPage"));
var _MentionsLegalesPage = _interopRequireDefault(require("Pages/MentionsLegalesPage"));
var _NotAllowedPage = _interopRequireDefault(require("Pages/NotAllowedPage"));
var _NotFoundPage = _interopRequireDefault(require("Pages/NotFoundPage"));
var _PasswordRecoveryPage = _interopRequireDefault(require("Pages/PasswordRecoveryPage"));
var _PreparationEmploiPage = _interopRequireDefault(require("Pages/PreparationEmploiPage"));
var _RecrutementPage = _interopRequireDefault(require("Pages/RecrutementPage"));
var _RessourcesPage = _interopRequireDefault(require("Pages/RessourcesPage"));
var _ValidateCandidatePage = _interopRequireDefault(require("Pages/ValidateCandidatePage"));
var _WelcomePage = _interopRequireDefault(require("Pages/WelcomePage"));
var _NewBlogPage = _interopRequireDefault(require("Pages/Creation/NewBlogPage"));
var _NewCandidateFrontPage = _interopRequireDefault(require("Pages/Creation/NewCandidateFrontPage"));
var _NewCandidatePage = _interopRequireDefault(require("Pages/Creation/NewCandidatePage"));
var _NewCompanyFrontPage = _interopRequireDefault(require("Pages/Creation/NewCompanyFrontPage"));
var _NewCompanyPage = _interopRequireDefault(require("Pages/Creation/NewCompanyPage"));
var _NewCVBackPage = _interopRequireDefault(require("Pages/Creation/NewCVBackPage"));
var _NewJobAdBackPage = _interopRequireDefault(require("Pages/Creation/NewJobAdBackPage"));
var _NewJobAdPage = _interopRequireDefault(require("Pages/Creation/NewJobAdPage"));
var _NewPartnerPage = _interopRequireDefault(require("Pages/Creation/NewPartnerPage"));
var _NewSectorPage = _interopRequireDefault(require("Pages/Creation/NewSectorPage"));
var _NewTestimonyPage = _interopRequireDefault(require("Pages/Creation/NewTestimonyPage"));
var _NewUserPage = _interopRequireDefault(require("Pages/Creation/NewUserPage"));
var _AdminCVDashboardPage = _interopRequireDefault(require("Pages/Lists/AdminCVDashboardPage"));
var _BlogsDashboardPage = _interopRequireDefault(require("Pages/Lists/BlogsDashboardPage"));
var _CandidateListDetailsPage = _interopRequireDefault(require("Pages/Lists/CandidateListDetailsPage"));
var _CandidateListPage = _interopRequireDefault(require("Pages/Lists/CandidateListPage"));
var _CandidatesDashboardPage = _interopRequireDefault(require("Pages/Lists/CandidatesDashboardPage"));
var _CompaniesDashboardPage = _interopRequireDefault(require("Pages/Lists/CompaniesDashboardPage"));
var _CompanyActivitiesDashboardPage = _interopRequireDefault(require("Pages/Lists/CompanyActivitiesDashboardPage"));
var _JobAdsDashboardPage = _interopRequireDefault(require("Pages/Lists/JobAdsDashboardPage"));
var _JobAdsFrontListDetailsPage = _interopRequireDefault(require("Pages/Lists/JobAdsFrontListDetailsPage"));
var _JobAdsFrontListPage = _interopRequireDefault(require("Pages/Lists/JobAdsFrontListPage"));
var _PartnersDashboardPage = _interopRequireDefault(require("Pages/Lists/PartnersDashboardPage"));
var _ProfessionalDomainsDashboardPage = _interopRequireDefault(require("Pages/Lists/ProfessionalDomainsDashboardPage"));
var _SectorsDashboardPage = _interopRequireDefault(require("Pages/Lists/SectorsDashboardPage"));
var _TestimoniesDashboardPage = _interopRequireDefault(require("Pages/Lists/TestimoniesDashboardPage"));
var _UsersDashboardPage = _interopRequireDefault(require("Pages/Lists/UsersDashboardPage"));
var _CandidateUpdateAccountCVPage = _interopRequireDefault(require("Pages/Update/CandidateUpdateAccountCVPage"));
var _CandidateUpdateAccountPage = _interopRequireDefault(require("Pages/Update/CandidateUpdateAccountPage"));
var _CompanyUpdateAccountPage = _interopRequireDefault(require("Pages/Update/CompanyUpdateAccountPage"));
var _UpdateBlogPage = _interopRequireDefault(require("Pages/Update/UpdateBlogPage"));
var _UpdateCandidatePage = _interopRequireDefault(require("Pages/Update/UpdateCandidatePage"));
var _UpdateCompanyPage = _interopRequireDefault(require("Pages/Update/UpdateCompanyPage"));
var _UpdateCVBackPage = _interopRequireDefault(require("Pages/Update/UpdateCVBackPage"));
var _UpdateJobAdBackPage = _interopRequireDefault(require("Pages/Update/UpdateJobAdBackPage"));
var _UpdateJobAdPage = _interopRequireDefault(require("Pages/Update/UpdateJobAdPage"));
var _UpdatePartnerPage = _interopRequireDefault(require("Pages/Update/UpdatePartnerPage"));
var _UpdateSectorPage = _interopRequireDefault(require("Pages/Update/UpdateSectorPage"));
var _UpdateTestimonyPage = _interopRequireDefault(require("Pages/Update/UpdateTestimonyPage"));
var _UpdateUserPage = _interopRequireDefault(require("Pages/Update/UpdateUserPage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = exports.default = {
  AboutPage: _AboutPage.default,
  BecomeVolonteer: _BecomeVolonteer.default,
  CandidateAccountPage: _CandidateAccountPage.default,
  CandidateCvPage: _CandidateCvPage.default,
  CompanyAccountPage: _CompanyAccountPage.default,
  DonatePage: _DonatePage.default,
  ForgottenPasswordPage: _ForgottenPasswordPage.default,
  FormationSensibilisationPage: _FormationSensibilisationPage.default,
  HomePage: _HomePage.default,
  InfoCandidatePage: _InfoCandidatePage.default,
  InfoCompanyPage: _InfoCompanyPage.default,
  JobAdCompanyPage: _JobAdCompanyPage.default,
  MaintienEmploiPage: _MaintienEmploiPage.default,
  MentionsLegalesPage: _MentionsLegalesPage.default,
  NotAllowedPage: _NotAllowedPage.default,
  NotFoundPage: _NotFoundPage.default,
  PasswordRecoveryPage: _PasswordRecoveryPage.default,
  PreparationEmploiPage: _PreparationEmploiPage.default,
  RecrutementPage: _RecrutementPage.default,
  RessourcesPage: _RessourcesPage.default,
  ValidateCandidatePage: _ValidateCandidatePage.default,
  WelcomePage: _WelcomePage.default,
  NewBlogPage: _NewBlogPage.default,
  NewCandidateFrontPage: _NewCandidateFrontPage.default,
  NewCandidatePage: _NewCandidatePage.default,
  NewCompanyFrontPage: _NewCompanyFrontPage.default,
  NewCompanyPage: _NewCompanyPage.default,
  NewCVBackPage: _NewCVBackPage.default,
  NewJobAdBackPage: _NewJobAdBackPage.default,
  NewJobAdPage: _NewJobAdPage.default,
  NewPartnerPage: _NewPartnerPage.default,
  NewSectorPage: _NewSectorPage.default,
  NewTestimonyPage: _NewTestimonyPage.default,
  NewUserPage: _NewUserPage.default,
  AdminCVDashboardPage: _AdminCVDashboardPage.default,
  BlogsDashboardPage: _BlogsDashboardPage.default,
  CandidateListDetailsPage: _CandidateListDetailsPage.default,
  CandidateListPage: _CandidateListPage.default,
  CandidatesDashboardPage: _CandidatesDashboardPage.default,
  CompaniesDashboardPage: _CompaniesDashboardPage.default,
  CompanyActivitiesDashboardPage: _CompanyActivitiesDashboardPage.default,
  JobAdsDashboardPage: _JobAdsDashboardPage.default,
  JobAdsFrontListDetailsPage: _JobAdsFrontListDetailsPage.default,
  JobAdsFrontListPage: _JobAdsFrontListPage.default,
  PartnersDashboardPage: _PartnersDashboardPage.default,
  ProfessionalDomainsDashboardPage: _ProfessionalDomainsDashboardPage.default,
  SectorsDashboardPage: _SectorsDashboardPage.default,
  TestimoniesDashboardPage: _TestimoniesDashboardPage.default,
  UsersDashboardPage: _UsersDashboardPage.default,
  CandidateUpdateAccountCVPage: _CandidateUpdateAccountCVPage.default,
  CandidateUpdateAccountPage: _CandidateUpdateAccountPage.default,
  CompanyUpdateAccountPage: _CompanyUpdateAccountPage.default,
  UpdateBlogPage: _UpdateBlogPage.default,
  UpdateCandidatePage: _UpdateCandidatePage.default,
  UpdateCompanyPage: _UpdateCompanyPage.default,
  UpdateCVBackPage: _UpdateCVBackPage.default,
  UpdateJobAdBackPage: _UpdateJobAdBackPage.default,
  UpdateJobAdPage: _UpdateJobAdPage.default,
  UpdatePartnerPage: _UpdatePartnerPage.default,
  UpdateSectorPage: _UpdateSectorPage.default,
  UpdateTestimonyPage: _UpdateTestimonyPage.default,
  UpdateUserPage: _UpdateUserPage.default
};
